import { connect } from 'react-redux';
import SignalR from './signalr';
import config from '../../run-config';
import { loadOrder, loadOrders } from '../reducers/order.reducers';
import { setSignalRState } from '../reducers/app.reducers';

const mapStateToProps = state => ({
  connectionHub: `${config.apiHost}/signalr`,
  accessToken: state.authentication.accessToken,
});

const mapDispatchToProps = dispatch => ({
  orderUpdated: (orderId, isNew) => {
    dispatch(loadOrder({ orderId, isNew }));
  },
  setSignalRState: (isAlive) => {
    dispatch(setSignalRState(isAlive));
    if (isAlive) {
      dispatch(loadOrders());
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(SignalR);
